// Centralised runtime configuration for the Console SPA. Values come from
// Vite environment variables so the same bundle can be rebuilt per
// deployment with the appropriate CloudFormation outputs.

interface RuntimeConfig {
  apiBaseUrl: string;
  cognitoAuthority: string;
  cognitoClientId: string;
  cognitoDomain: string;
}

function required(name: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing required environment variable ${name}`);
  return value;
}

export const config: RuntimeConfig = {
  apiBaseUrl: required("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
  cognitoAuthority: required("VITE_COGNITO_AUTHORITY", import.meta.env.VITE_COGNITO_AUTHORITY),
  cognitoClientId: required("VITE_COGNITO_CLIENT_ID", import.meta.env.VITE_COGNITO_CLIENT_ID),
  cognitoDomain: required("VITE_COGNITO_DOMAIN", import.meta.env.VITE_COGNITO_DOMAIN),
};
